export const config = {
  rowSelection: false,
  fieldControl: true,
  scroll: { y: `calc(100vh - 340px)` },
  columns: [
    { title: '通项ID', dataIndex: 'id', width: 200 },
    { title: '通项名称', dataIndex: 'itemName', width: 200, ellipsis: true },
    { title: '特项代码', dataIndex: 'specialCode', width: 200, ellipsis: true },
    { title: '子集选择方式', dataIndex: 'sonChooseTypeStr', width: 200, ellipsis: true },
    { title: '创建人', dataIndex: 'createdByName', width: 160, ellipsis: true },
    { title: '创建时间', dataIndex: 'createdTime', width: 180, itemType: 'dateTime' },
    { title: '状态', dataIndex: 'enabled', width: 90, fixed: 'right', render: 'switchRender' },
    { title: '操作', dataIndex: '#', width: 180, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    { label: '通项名称', name: 'itemNameKey' },
    {
      label: '状态',
      name: 'enabled',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        { label: '启用', value: true },
        { label: '禁用', value: false },
      ],
    },
  ],
  footer: [
    // { label: '下载导入模板', render: 'exportRender' },
    // { label: '批量导入', render: 'importRender' },
    { label: '新增', type: 'primary', events: ['onClick:onAdd'] },
  ],
}
